import React,{useState} from 'react'
import './Contact.css'
import contactBG from '../../img/contactBG.png'
const Contact = () => {
    const [email,setEmail] = useState('')
  return (
    <div className="contact">
        <div className="contact-title">
            <h3>Got any Question? </h3>
            <p>Reach out to us . Call us at +8809638011199</p>
        </div>
        <div className="contact-body">
            <form action="">
                <input placeholder='Your E-mail' type="text" value={email} onChange={e=>setEmail(e.target.value)}  />
                <button>Contact Us</button>
            </form>
        </div>
    </div>
  )
}

export default Contact